import { Context } from 'Context/Context';
import React from 'react'
import { useContext } from 'react';
import { useState } from 'react';
import TestModal from 'Modals/TestModal';
import { toast } from 'react-toastify';
import useIsMobile from 'Hooks/useIsMobile';
import { useNavigate } from 'react-router-dom';
import CaseCard, { StatusPill } from './CaseCard';
import { openCasePage, fmtDate } from './CaseStage';
import { CardStack, CaseBtn, EmptyState } from './CaseListUI';

function ReqToCloseCases({attorney, cases, setUpdateComp, reqRevCountArr, emptyText}) {
    const {userDetails} = useContext(Context);
    const isMobile = useIsMobile();
    const navigate = useNavigate();
    const usePage = !attorney;   // full case page; assistants keep the popup
    const userInfo = attorney ? attorney.userId : userDetails;
    const [showEachCase, setShowEachCase] = useState(false);
    const [singleCase, setSingleCase] = useState(null);
    const [closeMsg, setCloseMsg] = useState('');
    const [refreshList, setRefreshList] = useState(false);
 
    const submit = (key) => {
        //navigate("/profCaseDetails/"+cases?.[key]?._id);
        
        setShowEachCase(true);
        setSingleCase(cases?.[key]);
    }
    const showToastMsg = () => {
        console.log("closeMsg", closeMsg);
        toast.info("test msg")
        if(closeMsg && closeMsg !== '')
        {
            toast.info(closeMsg);
            setCloseMsg('');
        }   
        
    }
  if (showEachCase && singleCase) {
    return (
    <TestModal reqRevCountArr={reqRevCountArr} attorney={attorney}
    setCloseMsg={setCloseMsg}
    setRefreshList={setRefreshList}
    onClose={()=>{
               if (closeMsg) {
                   toast.info(closeMsg);
               }
               setShowEachCase(false);   // close modal
               setCloseMsg('');          // reset message
                if(refreshList )
                {
                    setUpdateComp(prev => !prev);
                    setRefreshList(false);
                }
    }} uploadNew={showEachCase} caseData={singleCase} setSingleCase={setSingleCase} setUpdateComp={setUpdateComp}/>
    )
  }
  if (!cases?.length) {
    return <EmptyState title={emptyText?.title || 'No pending closing yet'} body={emptyText?.body || 'Cases will appear here as they move into this stage. Try changing your filters.'} />
  }
  return (
    <CardStack>
        {cases.map((detail, key) => {
            const team = detail?.assistantId?.length ? detail.assistantId[0] : null;
            return (
                <CaseCard
                    key={detail?._id || key}
                    detail={detail.caseDetails}
                    userInfo={userInfo}
                    reqRevCountArr={reqRevCountArr}
                    showNames={true}
                    hideStats={true}
                    dimmed={!!(detail.isClosed || detail.is_deleted)}
                    onOpen={isMobile ? undefined : () => (usePage ? openCasePage(navigate, detail) : submit(key))}
                    headerPill={usePage ? <StatusPill tone="brass">Close requested{fmtDate(detail.updated_at) ? ' · ' + fmtDate(detail.updated_at) : ''}</StatusPill> : undefined}
                    footerNote={team ? <>Requested to close by team <b className="font-semibold text-navy">{team.firstName} {team.lastName}</b></> : null}
                    actions={<CaseBtn onClick={() => (usePage ? openCasePage(navigate, detail) : submit(key))} full={isMobile} style={isMobile ? { height: '46px', fontSize: '14px' } : undefined}>{usePage ? 'Open case →' : 'Complete case details →'}</CaseBtn>}
                />
            )
        })}
    </CardStack>
  )
}

export default ReqToCloseCases;
